import { Component, OnInit } from '@angular/core';
import { LocationService } from 'src/app/_service/location.service';
import { AlertifyService } from 'src/app/_service/alertify.service';
import { MatDialog } from '@angular/material';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-add-authority',
  templateUrl: './add-authority.component.html',
  styleUrls: ['./add-authority.component.css']
})
export class AddAuthorityComponent implements OnInit {

  locationForm: FormGroup;

  constructor(
    public locationService: LocationService,
    public alertify: AlertifyService,
    private fb: FormBuilder,
    public dialog: MatDialog) { 
      this.locationForm = fb.group({

        siteFormControl: new FormControl('', [
          Validators.required,
          this.WhitespaceValidator
        ]),
        // serviceareaFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // locationFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // sublocationFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // departmentFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        // subdepartmentFormControl: new FormControl('', [
        //   Validators.required
        // ]),
        aliasFormControl: new FormControl('', []).clearValidators(),
      });
    }

    public WhitespaceValidator(control: FormControl) {
      const isWhitespace = (control.value || '').trim().length === 0;
      const isValid = !isWhitespace;
      return isValid ? null : { 'whitespace': true };
  }


  model: any = {};
  locationExists: any = {};
  locationAdded: any = {};
  newAuthorityName: any;
  newAuthorityAliasName: any;
  isModified = false;

  ngOnInit() {
  }


  AddAuthority() {
    this.model.name = this.newAuthorityName.trim();

    if (this.newAuthorityAliasName !== undefined) {
      this.model.alias = this.newAuthorityAliasName.trim();
    }

    return this.locationService.addNewAuthority(this.model).subscribe(
      res => {
        this.locationExists = res.headers.get('locationexists');
        if (this.locationExists) {
          this.alertify.error(this.locationExists);
        }
        this.locationAdded = res.headers.get('locationadded');
        if (this.locationAdded) {
          this.alertify.success(this.locationAdded);
          this.isModified = true;
          this.dialog.closeAll();
        }
   }, error => {
     this.alertify.error('Something went wrong');
   });
}

}
